export default {
    addText: 'Dodaj fotografiju(e) ili video(e) (max 12MB)',
    dropText: 'Prevuci fotografiju(e) ili video(e) (max 12MB)',
    addImageText: 'Dodaj fotografiju(e) (max 12MB)',
    dropImageText: 'Prevuci fotografiju(e) (max 12MB)',
    removeFile: 'Ukloni fajl',
    preview: 'Pregled'
}
